import { useEffect, useState } from 'react';

const NAV_ITEMS = [
  { id: 'home', label: 'Home' },
  { id: 'servicos', label: 'Serviços' },
  { id: 'como-funciona', label: 'Como Funciona' },
  { id: 'credibilidade', label: 'Sobre' },
  { id: 'orcamento', label: 'Orçamento' },
  { id: 'contato', label: 'Contato' }
];

export function HeroSection() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNavigation = (sectionId: string) => {
    scrollToSection(sectionId);
    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (!isMenuOpen) {
      document.body.style.overflow = '';
      return;
    }

    const previousOverflow = document.body.style.overflow;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false);
      }
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isMenuOpen]);

  return (
    <>
      {isMenuOpen && (
        <div
          className="fixed inset-0 z-40 bg-slate-900/60 backdrop-blur-sm lg:hidden"
          aria-hidden="true"
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md shadow-lg transition-all duration-300">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="relative flex items-center justify-between py-3 sm:py-4 transition-all duration-300">
            <div className="flex items-center">
              <img
                src="https://mnnotgqwwzenmjfkzzmy.supabase.co/storage/v1/object/public/logotipos/master_vazamentos_header.jpg"
                alt="Master Caça Vazamentos - Detecção de Vazamentos em São Paulo"
                loading="lazy"
                decoding="async"
                className="w-60 h-auto object-contain drop-shadow-sm transition-all duration-300 sm:w-72 md:w-96 lg:w-[26rem]"
              />
            </div>

            <nav className="hidden lg:flex items-center gap-8">
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNavigation(item.id)}
                  className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors cursor-pointer"
                >
                  {item.label}
                </button>
              ))}
            </nav>

            <div className="hidden lg:block">
              <a
                href="https://wa.me/5511948948561?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20detec%C3%A7%C3%A3o%20de%20vazamento.%20Pode%20me%20ajudar%3F"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-green-600 text-white hover:bg-green-700 shadow-md hover:shadow-lg font-semibold h-11 rounded-md px-8"
              >
                WhatsApp
              </a>
            </div>

            <button
              className="lg:hidden inline-flex items-center justify-center rounded-md p-2 text-slate-700 hover:bg-slate-100 transition-colors"
              aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen((prev) => !prev)}
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`} aria-hidden="true"></i>
            </button>

            {isMenuOpen && (
              <div className="absolute top-full left-0 right-0 mt-3 rounded-2xl border border-slate-100 bg-white shadow-2xl lg:hidden">
                <div className="px-4 py-3">
                  {NAV_ITEMS.map((item) => (
                    <button
                      key={`mobile-${item.id}`}
                      onClick={() => handleNavigation(item.id)}
                      className="flex w-full items-center justify-between rounded-lg px-3 py-3 text-left text-sm font-medium text-slate-700 transition-colors hover:bg-slate-100"
                    >
                      <span>{item.label}</span>
                      <i className="ri-arrow-right-up-line text-base text-blue-600"></i>
                    </button>
                  ))}
                  <a
                    href="https://wa.me/5511948948561?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20detec%C3%A7%C3%A3o%20de%20vazamento.%20Pode%20me%20ajudar%3F"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-2 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-green-600 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-green-700"
                  >
                    <i className="ri-whatsapp-line text-lg"></i>
                    Solicitar orçamento
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="relative flex items-center justify-center overflow-hidden min-h-[70vh] md:min-h-screen">
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/85 via-blue-800/75 to-blue-900/85 z-10"></div>
          <img
            src="https://mnnotgqwwzenmjfkzzmy.supabase.co/storage/v1/object/public/logotipos/equipe_master_vazamentos.png"
            alt="Equipe Master Caça Vazamentos - Profissionais especializados em detecção de vazamentos"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="container mx-auto px-4 sm:px-6 relative z-20 pt-28 sm:pt-32 pb-16 sm:pb-20">
          <div className="max-w-4xl mx-auto text-center text-white">
            <div className="animate-fade-in">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight drop-shadow-2xl text-white">
                Localizamos vazamentos<br />
                <span className="text-blue-200 drop-shadow-2xl">sem quebrar paredes ou pisos</span>
              </h1>
            </div>

            <div className="animate-fade-in-up">
              <p className="text-base sm:text-lg md:text-2xl mb-10 text-white font-medium max-w-3xl mx-auto drop-shadow-xl">
                Diagnóstico preciso, laudo técnico aceito pela SABESP e atendimento imediato em São Paulo e região. Visita gratuita com orçamento feito na hora.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12 animate-scale-in">
              <a
                href="https://wa.me/5511948948561?text=Ol%C3%A1%2C%20gostaria%20de%20solicitar%20um%20or%C3%A7amento%20para%20detec%C3%A7%C3%A3o%20de%20vazamento.%20Pode%20me%20ajudar%3F"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-20 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-blue-600 text-white hover:bg-blue-700 shadow-2xl hover:shadow-blue-500/25 hover:scale-105 font-bold rounded-lg text-base sm:text-lg h-12 sm:h-14 px-8 w-full sm:w-auto border-2 border-blue-500"
              >
                <i className="ri-phone-line text-xl"></i>
                Solicitar Orçamento Grátis
              </a>
              <a
                href="#servicos"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-20 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border-2 border-white text-white bg-white/20 backdrop-blur-sm hover:bg-white hover:text-blue-900 hover:scale-105 font-semibold rounded-lg text-base sm:text-lg h-12 sm:h-14 px-8 w-full sm:w-auto shadow-xl"
              >
                <i className="ri-service-line text-xl"></i>
                Conheça Nossos Serviços
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-6 sm:gap-8 animate-fade-in-up">
              <div className="flex items-center gap-3 bg-white/25 backdrop-blur-sm rounded-full px-4 py-2 border border-white/30 shadow-lg">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-sm font-semibold text-white drop-shadow-lg">Sem Quebra Desnecessária</span>
              </div>
              <div className="flex items-center gap-3 bg-white/25 backdrop-blur-sm rounded-full px-4 py-2 border border-white/30 shadow-lg">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-sm font-semibold text-white drop-shadow-lg">Laudo SABESP</span>
              </div>
              <div className="flex items-center gap-3 bg-white/25 backdrop-blur-sm rounded-full px-4 py-2 border border-white/30 shadow-lg">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-sm font-semibold text-white drop-shadow-lg">Atendimento Rápido</span>
              </div>
              <div className="flex items-center gap-3 bg-white/25 backdrop-blur-sm rounded-full px-4 py-2 border border-white/30 shadow-lg">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-sm font-semibold text-white drop-shadow-lg">Visita Gratuita</span>
              </div>
              <div className="flex items-center gap-3 bg-white/25 backdrop-blur-sm rounded-full px-4 py-2 border border-white/30 shadow-lg">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-sm font-semibold text-white drop-shadow-lg">Orçamento na Hora</span>
              </div>
            </div>
          </div>
        </div>

      </section>
    </>
  );
}
